// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d421","importantInfo":"styles_importantInfo__1ceti"};